export const SCROLL_SPEED_MS = 300;
export const ZOOM_STEP = 0.25;
export const ZOOM_ON_CLICK_STEP = ZOOM_STEP * 3;
export const DEFAULT_ZOOM_FACTOR = 1;
export const MAX_ZOOM_IN = 4;
export const MAX_ZOOM_OUT = 0.25;
export const SCROLL_DIRECTION_DOWN = 'DOWN';
export const SCROLL_DIRECTION_UP = 'UP';
export const VISIBLE_PAGES_AMOUNT = {
    BY_SCROLL_FORWARD: 4,
    BY_SCROLL_BACKWARD: 2
};
// Caps canvas pixel count, which grows quadratically with devicePixelRatio.
export const MAX_PAGE_DEVICE_PIXEL_RATIO = 2;
export const THUMBNAIL_DEVICE_PIXEL_RATIO = 1;

// Same floor pdf.js' own viewer uses for its PDFPageViewBuffer.
export const MIN_PAGE_BUFFER_SIZE = 10;

export const PAGE_RENDER_STATE = {
    WAITING: 'waiting',
    LOADING_PAGE: 'loading-page',
    RENDERING: 'rendering',
    RENDERED: 'rendered',
    FAILED: 'failed'
};

export const FOOTER_HEIGHT_PX = 30;
export const FOOTER_MARGIN_BOTTOM_PX = 16;
export const FOOTER_TOTAL_HEIGHT_PX = FOOTER_HEIGHT_PX + FOOTER_MARGIN_BOTTOM_PX;
